module.exports = __webpack_public_path__ + "static/media/0025_LES_ENSEIGNES_LE_POISSONNIER_LETTRE_A_LETTRE.814455c6.webp";